import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const mediaUrl = (path) =>
  path ? `${API_BASE}/media/${path}` : null;

// Same-origin URL that forces the browser to DOWNLOAD (not open) the media with a clean filename (D30).
export const downloadUrl = (path, filename) =>
  path ? `${API_BASE}/media/${path}?dl=${encodeURIComponent(filename || "metafora")}` : null;

export const publicMediaUrl = (path) =>
  path ? `${API_BASE}/public/media/${path}` : null;

export default api;
